import { getSignedUrl } from '@/services/s3FileManager';

export type UrlType = string | File | null | undefined;

export const resolveUrl = async (url: UrlType): Promise<string | null> => {
	if (!url) return null;

	// Handle File objects
	if (url instanceof File) {
		try {
			return URL.createObjectURL(url);
		} catch (err) {
			console.error('Failed to create object URL:', err);
		}
		return null;
	}

	// Skip resolution for direct URLs
	if (
		url.startsWith('http') ||
		url.startsWith('blob:') ||
		url.startsWith('data:')
	) {
		return url;
	}

	// Use sessionStorage to cache url as cache key
	const cachedUrl = sessionStorage.getItem(url as string);
	if (cachedUrl) {
		const { signedUrl, expiresIn, time = 0 } = JSON.parse(cachedUrl);
		if (time + expiresIn > Date.now()) {
			return signedUrl;
		}
	}

	const response = await getSignedUrl(url as string);
	if (response) {
		sessionStorage.setItem(url as string, JSON.stringify(response));
		return response.signedUrl;
	}
	return null;
};
